import { PostMethod, GetMethod } from '../../serviceHelper';

const getMethods = (service: 'BuildManager', controller: 'BuildManager') => ({
	BuildProject: new PostMethod<any, any>({
		service,
		controller,
		method: 'BuildProject'
	}),
	BuildServer: new PostMethod<any, any>({
		service,
		controller,
		method: 'BuildServer'
	}),
	BuildClient: new PostMethod<any, any>({
		service,
		controller,
		method: 'BuildClient'
	}),
	DeployProject: new PostMethod<any, any>({
		service,
		controller,
		method: 'DeployProject'
	}),
	DeployProjects: new PostMethod<any, any>({
		service,
		controller,
		method: 'DeployProjects'
	}),
	PublishProject: new PostMethod<any, any>({
		service,
		controller,
		method: 'PublishProject'
	}),
	Cancel: new PostMethod<any, any>({
		service,
		controller,
		method: 'Cancel'
	}),
	GetDeployAgents: new GetMethod<any, any>({
		service,
		controller,
		method: 'GetDeployAgents'
	}),
	GetBuildAgents: new GetMethod<any, any>({
		service,
		controller,
		method: 'GetBuildAgents'
	}),
	GetSdkVersions: new GetMethod<any, any>({
		service,
		controller,
		method: 'GetSdkVersions'
	})
});

export { getMethods };
